import {
	cloneDeep, 
	uniqBy
} from "lodash";
import moment from "moment";

//2243 sometime...
const Date_MAX = new Date(8640000000000);

/**
 * Get all seasons that touch the given effectiveRanges
 * @param {*array} effectiveRanges 
 * @param {*array} seasons 
 * @returns {*array} matchedSeasons 
 */

export function getSeasonsByEffectiveRanges(effectiveRanges, seasons, useFederalScopeOverride) {
	const reducer = (includedSeasons, currentSeason) => {
		const seasonBegin = moment(currentSeason.BeginInclusive);
		const seasonEnd = moment(currentSeason.EndExclusive);

		if(includedSeasons.some(season => season.Id === currentSeason.Id)) {
			return includedSeasons;
		}

		const matchingSeasons = [];
		for(const range of effectiveRanges) {
			const rangeStart = moment(range.Start);
			const rangeEnd = moment(range.End ?? Date_MAX);
			if(rangeStart.isSameOrAfter(seasonEnd) || rangeEnd.isSameOrBefore(seasonBegin) || ((useFederalScopeOverride ? "FED" : range.Scope) !== currentSeason.Scope)) {
				continue;
			} 
			const currentSeasonCopy = cloneDeep(currentSeason);
			if((rangeStart.isSameOrBefore(seasonBegin) && rangeEnd.isBefore(seasonEnd))
				|| (rangeStart.isAfter(seasonBegin) && rangeEnd.isSameOrAfter(seasonEnd))) {
				currentSeasonCopy.Periods = currentSeasonCopy.Periods.filter(
					p => moment(p.EndExclusive).isAfter(rangeStart) && moment(p.BeginInclusive).isSameOrBefore(rangeEnd)
				);
			}
			matchingSeasons.push(currentSeasonCopy);
		}
		return matchingSeasons.length ? [...includedSeasons, ...matchingSeasons] : includedSeasons;
	};
	const matchedSeasons = seasons.reduce(reducer, []);

	const recombinedSeasons = matchedSeasons.reduce((allSeasons, currentSeason) => {
		if(allSeasons.some(season => season.Id === currentSeason.Id)) {
			const matchingSeason = allSeasons.find(s => s.Id === currentSeason.Id);
			matchingSeason.Periods = matchingSeason.Periods.concat(currentSeason.Periods);
			matchingSeason.Periods = uniqBy(matchingSeason.Periods, p => p.Id);
			matchingSeason.Periods.sort((a, b) => moment(a.BeginInclusive).isSame(moment(b.BeginInclusive)) ? 0 : moment(a.BeginInclusive).isBefore(b.BeginInclusive) ? -1 : 1);
		}
		else {
			allSeasons.push(currentSeason);
		}

		return allSeasons;
	}, []);

	return recombinedSeasons;
}